
/* eslint-disable import/no-named-default */
import customLanguageEnSg from './sdgrouphub/language/en-SG'
import customLanguageZhCn from './sdgrouphub/language/zh-CN'
import customLanguageTh from './sdgrouphub/language/th-TH'
// import customLanguageEnSg from './koi/language/en-SG'
// import customLanguageZhCn from './koi/language/zh-CN'

export const enableTranslation = true;

// export const customLanguages = {
//     [`en-SG`]: {},
//     [`zh-CN`]: {},
// }

export const customLanguages = {
    [`en-SG`]: customLanguageEnSg,
    [`zh-CN`]: customLanguageZhCn,
    [`th-TH`]: customLanguageTh,
}